import renderPlansCount from 'sites/enroll.pivothealth.com/census/controller/renderPlansCount'
import urlParamsToObject from '@hc-frontend/shared-assets/src/js/utils/url/urlParamsToObject'
import toUrlParams from '@hc-frontend/shared-assets/src/js/utils/url/toUrlParams'
import executeWhenFinishToRender from 'core/renders/executeWhenFinishToRender'
import isSalesCenterSubDomain from 'utils/pivot/isSalesCenterSubDomain'
import sendApplicantContext from 'core/services/sendApplicantContext'
import getCoverageDuration from 'core/services/getCoverageDuration'
import initializerControllers from './initializerControllers'
import getFiltersFromUrl from 'core/DOM/getFiltersFromUrl'
import addEventListener from 'utils/DOM/addEventListener'
import ifNotTrueExecute from 'utils/ifNotTrueExecute'
import toastNotification from 'pug/toastNotification'
import { UPDATED_START_FROM_SERVER } from 'messages'
import scrollToError from 'core/DOM/scrollToError'
import { stringToDate, dateToString } from '@hc-frontend/utils'
import getURLParams from 'utils/DOM/getURLParams'
import toggleClass from 'utils/DOM/toggleClass'
import isArray from 'utils/validation/isArray'
import isNumber from 'utils/number/isNumber'
import handleMembers from './handleMembers'
import saveToStorage from './saveToStorage'
import innerHTML from 'utils/DOM/innerHTML'
import isEmpty from 'utils/object/isEmpty'
import getById from 'utils/DOM/getById'
import { QUOTES } from 'sites/routes'
import permittedRoutes from 'core/constants/permittedRoutes'
import validateRoute from 'utils/validation/validateRoute'
import storage from 'proxy-storage'
import config from '../config'
import {
  IS_SHORT_TERM,
  IS_AGENT,
  IS_FIXED_BENEFIT_MEDICAL,
  IS_BRIDGE_TO_MEDICARE,
  IS_DENTAL_AND_VISION,
  MULTI_CARRIER_ENABLED
} from 'core/constants/environment'
import { BTM, DENTAL_STAND_ALONE, FIXED } from 'core/constants/products'
import getProductsWithCoverageFlag from 'core/DOM/getProductsWithCoverageFlag'
import renderHeaderProducts from 'core/DOM/renderHeaderProducts'
import Templater from '@hc-frontend/shared-assets/src/js/utils/dom/Templater'
import { deepClone, getISODate } from '@hc-frontend/utils'
import { findApplicant } from '@hc-frontend/business'
import { setDOBRules } from 'core/controllers/validations/getErrorToDOB'
import { preventOnCloseEvent } from 'core/services/onClose'
import initSmartly from 'core/initPage/absmartly'
import updateSessionWithEmail from 'utils/pivot/session/updateSessionWithEmail'
import sendSnowplowClickTrackEvent from '../sendSnowplowClickTrackEvent'
import { validateDOBControllers } from './validateDOBControllers'
import updateMultiCarrierEligibility from 'core/controllerPlans/update-multi-carrier-eligibility'
import store from 'utils/store/withMiddleware'

const headerMenu = getById('header-menu')
const menuTemplate = headerMenu ? Templater(headerMenu.innerText) : undefined

const childOnlyWrap = getById('child-only-wrap')
const controllers = initializerControllers(document.forms.form, handleUpdateLocation)

let lastState
let lastSDate

export function updateProductInformation(product: string | undefined): void {
  toggleClass(document.body, 'fbm', false)

  const isSTM = product === 'stm'

  if (isSTM) {
    toggleClass(childOnlyWrap, 'error', false)
  }

  toggleClass(document.body, 'stm', isSTM)

  setDOBRules(product, childOnlyNode.checked)
  if (controllers.dob.getStatus().value) {
    controllers.dob.validate()
  }

  handleMembers.updateControllerRules(product)
  const hasSelectedProduct = isSTM
  toggleClass('#wrap-period', 'd-none', !hasSelectedProduct)
}

function validateRedirect(urlParams: object): object {
  const { backTo } = urlParams
  const [route, search] = backTo.split('?')
  const validRoute = validateRoute(route, permittedRoutes, permittedRoutes._default)

  if (validRoute !== route || search == null) {
    return { ...urlParams, backTo: validRoute }
  }

  return { ...urlParams, backTo: `${validRoute}?${search}` }
}

function handleDateAfterUpdateLocation(data, hcStorage) {
  if (data.date) {
    const serverStartDate = stringToDate(data.date)
    const sdate = stringToDate(hcStorage.sdate)

    if (sdate && sdate.getTime() < serverStartDate.getTime()) {
      toastNotification(UPDATED_START_FROM_SERVER)
      const newStorage = deepClone(hcStorage)
      newStorage.sdate = dateToString(serverStartDate)
      storage.setItem('hc', newStorage)

      controllers.sdate.updateNextStartDate(newStorage.sdate)
    }
  }
}

async function handlePeriodVisibility(coverageData, period: number) {
  const newPeriod =
    coverageData.coverage &&
    isArray(coverageData.coverage) &&
    coverageData.coverage.includes(period)
      ? period
      : coverageData.longerPeriod

  controllers.period.setValue({ data: coverageData, period: newPeriod })
  innerHTML('.shorterPeriod', coverageData.shorterPeriod === 90 ? 90 : 180)
}

function handleCoverageVisibility(coverageData, products) {
  if (!IS_SHORT_TERM) {
    return
  }

  const hasFBMCoverage = false
  const hasSTMCoverage = !isEmpty(coverageData.coverage)
  const withoutCoverage = !hasFBMCoverage && !hasSTMCoverage

  toggleClass(document.body, 'no-coverage', withoutCoverage)
  toggleClass('#wrap-coverage', 'd-none', withoutCoverage)

  controllers.period.makeOptional(false)
  controllers.period.validate()
}

async function handleUpdateLocation(hcStorage) {
  const state = hcStorage.location.state_acronym

  if (MULTI_CARRIER_ENABLED) {
    await updateMultiCarrierEligibility(store.getState(), {
      stateAcronym: state
    })
  }

  if (lastState === state && lastSDate === hcStorage.sdate) {
    return undefined
  }

  lastState = state
  lastSDate = hcStorage.sdate

  const { error, data } = await getCoverageDuration(
    hcStorage.location.state_acronym,
    getISODate(new Date(hcStorage.sdate))
  )

  const smartlySDK = initSmartly()

  const disableBTM = smartlySDK ? smartlySDK.treatment('PH_BTM_REDIRECT') : 1

  let products = getProductsWithCoverageFlag({ error, data })

  if (disableBTM) {
    products = products.filter(product => product.name !== 'btm')
  }

  handleCoverageVisibility(data, products)

  if (menuTemplate) {
    renderHeaderProducts(menuTemplate, products)
  }

  let notCoverage = error
  if (!notCoverage) {
    if (IS_SHORT_TERM) {
      notCoverage = isEmpty(data.coverage)
    }

    if (IS_BRIDGE_TO_MEDICARE) {
      notCoverage = !data.countByProduct[BTM]
    }

    if (IS_DENTAL_AND_VISION) {
      notCoverage = !data.countByProduct[DENTAL_STAND_ALONE]
    }
    if (IS_FIXED_BENEFIT_MEDICAL) {
      notCoverage = !data.countByProduct[FIXED]
    }
  }

  if (controllers.period) {
    handlePeriodVisibility(data, +hcStorage.period)
  }

  if (!IS_SHORT_TERM) {
    toggleClass(document.body, 'no-coverage', notCoverage)
  }
  handleDateAfterUpdateLocation(data, hcStorage)
  renderPlansCount(data.countByProduct)

  window.dataLayer.push({ event: 'PRODUCT_COVERAGES_LOADED_IN_CENSUS' })
}

function updatePeriodToPath(urlParams, period) {
  let path
  const backToUrl = urlParams.backTo
  const backToBase = backToUrl.split('?')[0]
  const backToProps = urlParamsToObject(backToUrl)
  const id = +backToProps['planid']

  if (isNumber(id)) {
    if (IS_BRIDGE_TO_MEDICARE) {
      path = backToUrl
    } else {
      backToProps.period = period
      backToProps.policies = urlParams.policies || 1
      path = `${backToBase}${toUrlParams(backToProps)}`
    }
  } else {
    try {
      path = backToUrl.replace(/^(.*>)(\d+)(-months)$/, `$1${Math.round(period / 30)}$3`)
    } catch (e) {
      path = backToUrl
    }
  }

  return path
}

addEventListener('#form', 'submit', handleSubmit)

async function handleSubmit(e) {
  e.preventDefault()
  let isValidForm = true
  const allControllers = { ...controllers, ...handleMembers.getControllers() }
  const valuesForm = {}

  for (const key in allControllers) {
    const status = allControllers[key].getStatus()

    ifNotTrueExecute(status.valid, allControllers[key].validate)
    isValidForm = isValidForm && status.valid
    valuesForm[key] = status.value
  }

  if (IS_FIXED_BENEFIT_MEDICAL) {
    valuesForm.childOnly = childOnlyNode.checked
  }

  let product = undefined
  let isLongTerm = false
  if (IS_SHORT_TERM) {
    product = 'stm'
    valuesForm.childOnlySMT = childOnlyNode.checked
    isLongTerm = product === 'fbm'
    if (isLongTerm) {
      valuesForm.childOnly = childOnlyNode.checked
    }
  }

  const validateChildOnly = IS_FIXED_BENEFIT_MEDICAL || isLongTerm

  if (validateChildOnly) {
    toggleClass(childOnlyWrap, 'error', valuesForm.childOnly && !valuesForm.dob_1)
    isValidForm = isValidForm && !(valuesForm.childOnly && !valuesForm.dob_1)
  }

  const errors = document.querySelector('.week.error')

  if (!errors && isValidForm) {
    if (valuesForm.email) {
      await updateSessionWithEmail(valuesForm.email)
    }

    const hcStorage = saveToStorage(valuesForm)
    if (IS_SHORT_TERM) {
      sendSnowplowClickTrackEvent(hcStorage)
    }
    preventOnCloseEvent()
    Promise.all([sendApplicantContext(hcStorage, config)]).then(() => {
      window.location = getNewRoute({
        coverageType: valuesForm.coverageType,
        period: valuesForm.period
      })
    })
  } else {
    scrollToError()
  }
}

/** Function to get the url according to the max duration and months selected */
function getUrlParameters() {
  const periodSelector = document.getElementById('containerPeriod')
  const selectedEightMonths = periodSelector.querySelector('input[id="period-8"]:checked')
  const selectedTwelveMonths = periodSelector.querySelector(
    'input[id="period-12"]:checked'
  )
  const durationEight = document.getElementById('period-8')
  const durationTwelve = document.getElementById('period-12')

  let months
  if (selectedEightMonths) {
    months = 8
  } else if (selectedTwelveMonths) {
    months = 12
  } else {
    months = 4
  }

  let duration
  if (durationEight) {
    duration = 8
  } else if (durationTwelve) {
    duration = 12
  } else {
    duration = 4
  }
  return `?months=${months}&maxDuration=${duration}`
}

function getNewRoute({ coverageType = 'stm', period }) {
  const urlParams = getURLParams()
  const backTo = urlParams.backTo ?? false

  if (IS_SHORT_TERM) {
    if (coverageType === 'fbm') {
      return [`/product/fixed-benefit-medical/quotes`, getFiltersFromUrl()]
        .filter(Boolean)
        .join('?')
    }
  }
  const returnedUrl = backTo
    ? updatePeriodToPath(validateRedirect(urlParams), period)
    : [QUOTES, getFiltersFromUrl()].filter(Boolean).join('?')

  if (MULTI_CARRIER_ENABLED && !IS_DENTAL_AND_VISION) {
    return returnedUrl + getUrlParameters()
  }
  return returnedUrl
}

const optionalInputs = {}

function makeFieldOptional(name) {
  if (!optionalInputs[name]) {
    optionalInputs[name] = false
    const node = document.querySelector(`[for=${name}]`)

    node.innerHTML = node.innerText + ' <small>(optional)</small>'
    controllers[name].makeOptional()
  }
}

// expose global functions to make optional inputs
window.makeEmailOptional = makeFieldOptional.bind(undefined, 'email')
window.makeFirstNameOptional = makeFieldOptional.bind(undefined, 'fname')
window.makeLastNameOptional = makeFieldOptional.bind(undefined, 'lname')

if (IS_AGENT && !isSalesCenterSubDomain()) {
  makeFieldOptional('email')
}

makeFieldOptional('phone')
makeFieldOptional('lname')

const wrapPhone = document.getElementById('wrap-phone')
const wrapLastName = document.getElementById('wrap-lname')

if (isSalesCenterSubDomain()) {
  wrapPhone && toggleClass(wrapPhone, 'd-none', false)
} else {
  if (wrapPhone) {
    toggleClass(wrapPhone, 'd-none', true)
  }
  if (wrapLastName) {
    toggleClass(wrapLastName, 'd-none', true)
  }
}

const childMessage = getById('child-only-message')
const childOnlyNode = getById('child-only')
const applicantDobLabel = document.querySelector('[for="dob"]')
const addSpouseButton = getById('add-spouse')
const spouseWrap = getById('spouse-wrap')

function handleClickOnlyChild(e) {
  const isChildOnly = e.target.checked
  toggleClass(childMessage, 'd-none', !isChildOnly)
  toggleClass(addSpouseButton, 'd-none', isChildOnly)
  toggleClass(spouseWrap, 'd-none', isChildOnly)

  if (IS_SHORT_TERM) {
    const coverageType = 'stm'
    setDOBRules(coverageType, isChildOnly)
    validateDOBControllers({ ...controllers, ...handleMembers.getControllers() })

    toggleClass(document.body, 'child-only', isChildOnly)
    handleMembers.setChildOnlyApplication(isChildOnly)
  }

  applicantDobLabel.innerHTML = `Date of Birth${
    applicantDobLabel && isChildOnly
      ? ' <small class="d-stm-none">(contracting adult)</small>'
      : ''
  }`
}

if (IS_FIXED_BENEFIT_MEDICAL || IS_SHORT_TERM) {
  addEventListener(childOnlyNode, 'change', handleClickOnlyChild)
}

$('body').on('change', '.week input', function (e) {
  toggleClass(
    e.target.parentElement.parentElement.parentElement,
    'error',
    e.target.value !== 'yes'
  )
})

function getProductByPath(backToURL: string): 'stm' | 'fbm' | undefined {
  const fbmProduct = '/product/fixed-benefit-medical'
  const stmProduct = '/product/short-term-health-insurance'

  return backToURL.indexOf(stmProduct) !== -1
    ? 'stm'
    : backToURL.indexOf(fbmProduct) !== -1
    ? 'fbm'
    : undefined
}

async function updateFormData(hcStorage) {
  controllers.sdate.setValue(hcStorage.sdate)
  let isChildOnly = false
  controllers.email.setValue(hcStorage.contact.email_address)

  controllers.phone.setValue(hcStorage.contact.phone_home)

  // update members information
  const applicant = findApplicant(hcStorage.members)
  controllers.dob.setValue(applicant.stringDOB)
  if (applicant.dob) {
    controllers.dob.validate()
  }
  controllers.gender.setValue(applicant.gender)
  controllers.fname.setValue(applicant.firstName)
  controllers.lname.setValue(applicant.lastName)
  handleMembers.loadMembers(hcStorage.members)
  isChildOnly = IS_SHORT_TERM ? hcStorage.childOnlySMT : hcStorage.childOnly

  if (IS_SHORT_TERM) {
    const urlParams = getURLParams()

    const backTo = urlParams.backTo || ''
    const coverageType = getProductByPath(backTo)

    if (hcStorage.coverageTypeSelection) {
      controllers.coverageType.setValue(hcStorage.coverageTypeSelection)
      updateProductInformation(hcStorage.coverageTypeSelection)
    } else if (backTo) {
      controllers.coverageType.setValue(coverageType)
    }

    childOnlyNode.checked = isChildOnly
    handleClickOnlyChild({ target: childOnlyNode })
  }

  if (hcStorage.location.zip_code) {
    controllers.zip.setValue(hcStorage)

    await handleUpdateLocation(hcStorage)
  }

  if (IS_FIXED_BENEFIT_MEDICAL) {
    childOnlyNode.checked = isChildOnly
    handleClickOnlyChild({ target: childOnlyNode })
  }

  executeWhenFinishToRender(hcStorage)
}

export default updateFormData
